import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {environment} from 'src/environments/environment';
import {ApiCalls} from '../constants/api-constants';
import {ActivationResponse} from '../model/activation.model';

@Injectable({
  providedIn: 'root',
})
export class ActivationService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {
  }

  /**
   * activate
   */
  public activate(accessCode: string, accountNumber: string, cbpid?: string): Observable<ActivationResponse> {
    const url = `${this.baseUrl}/${ApiCalls.activation.activate}`;
    const payload = {
      accountNumber,
      cbpid,
      subType: environment.subType[0],
      accessCode,
    }
    const apimSubKey = window.location.href.indexOf("qa") > -1 || window.location.href.indexOf("local") > -1? environment.apimSubscriptionKey.qa : environment.apimSubscriptionKey.prod;
    const headers = new HttpHeaders({
        'apim-subscription-key': apimSubKey
      });
    const options = { headers: headers };
    return this.http.post<ActivationResponse>(url, payload, options)
      .pipe(
        map(res => {
          if (res?.status?.code !== "200.000") {
            throw {
              status: res?.status?.code?.substring(0, 3)
            };
          }
          return res
        })
      );
  }
}